import { isPresent } from 'utils/isPresent';

import { LocalStorage } from '../../components/Common/Utils/local_storage';

import { SB_KEY } from './Data';

const getStoredToken = () => {
  if (LocalStorage.isStorageEnabled() && isPresent(LocalStorage.getItem(SB_KEY))) {
    const { expires_at: expiresAt, token } = JSON.parse(LocalStorage.getItem(SB_KEY));
    if (new Date(expiresAt) > new Date()) return token;

    LocalStorage.removeItem(SB_KEY);
  }
  return null;
};

export default getStoredToken;
